/**
 * VÍDEO 8 — RESOLUÇÃO
 * "Marketing previsível existe. É sistema."
 * 10s | 720×900 | SEM ÁUDIO
 * Copy: BoardCopy (Hormozi + Sugarman)
 */

import React from "react";
import {
  AbsoluteFill,
  useCurrentFrame,
  interpolate,
  Easing,
  Sequence,
  spring,
} from "remotion";
import {CLAMP} from "../../presets/idv";

const T = {
  light: { bg: "#F7F6F2", headline: "#1A1A1A", body: "#4A4A4A", muted: "#999999" },
  accent: "#E84545",
  accentBg: "rgba(232,69,69,0.15)",
};

const FONT_SERIF = "'Playfair Display', Georgia, serif";
const FONT_MONO = "'JetBrains Mono', 'Fira Code', monospace";
const FONT_SANS = "'Inter', system-ui, sans-serif";

const SZ = { top: 70, sides: 50, bottom: 80 };
const CW = 720 - SZ.sides * 2;

const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

const Headline: React.FC<{children: React.ReactNode; size?: number; color: string; delay?: number}> =
  ({children, size = 50, color, delay = 0}) => {
  const frame = useCurrentFrame();
  return (
    <div style={{
      opacity: fadeIn(frame, delay, delay + 15),
      transform: `translateY(${slideUp(frame, delay, delay + 15)})`,
      fontFamily: FONT_SERIF, fontSize: size, fontWeight: 700, lineHeight: 1.15, color, maxWidth: CW,
    }}>{children}</div>
  );
};

const Checklist: React.FC<{items: string[]; delay?: number}> = ({items, delay = 20}) => {
  const frame = useCurrentFrame();
  const textColor = T.light.headline;
  return (
    <div style={{display: "flex", flexDirection: "column", gap: 14, marginTop: 8}}>
      {items.map((item, i) => {
        const fd = delay + i * 10;
        const itemSpring = spring({frame: frame - fd, fps: 30, config: {damping: 14, stiffness: 180, mass: 1}});
        const bulletSpring = spring({frame: frame - fd, fps: 30, config: {damping: 16, stiffness: 200, mass: 0.8}});
        return (
          <div key={i} style={{
            display: "flex", alignItems: "center", gap: 12,
            opacity: interpolate(itemSpring, [0, 0.5, 1], [0, 0, 1], {extrapolateRight: CLAMP}),
            transform: `translateX(${interpolate(itemSpring, [0, 1], [15, 0], {extrapolateRight: CLAMP, easing: Easing.out(Easing.ease)})}px)`,
          }}>
            <div style={{
              width: 22, height: 22, borderRadius: "50%", background: T.accent,
              display: "flex", alignItems: "center", justifyContent: "center",
              transform: `scale(${interpolate(bulletSpring, [0, 0.6, 1], [0.3, 1.1, 1], {extrapolateRight: CLAMP})})`, flexShrink: 0,
            }}>
              <span style={{fontSize: 11, color: "#fff", fontWeight: 700}}>✓</span>
            </div>
            <div style={{
              fontFamily: FONT_SERIF, fontSize: 21, fontWeight: 600, lineHeight: 1.3, color: textColor,
            }}>{item}</div>
          </div>
        );
      })}
    </div>
  );
};

const Footer: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <div style={{position: "absolute", bottom: 40, left: SZ.sides, right: SZ.sides, display: "flex", justifyContent: "space-between", alignItems: "center", opacity: fadeIn(frame, 40, 50)}}>
      <span style={{fontFamily: FONT_SANS, fontSize: 15, fontWeight: 400, color: T.light.muted}}>@guilhermeribeiro.ai</span>
      <span style={{fontFamily: FONT_SANS, fontSize: 13, fontWeight: 500, color: T.light.muted}}>8/9</span>
    </div>
  );
};

const SeriesLabel: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <div style={{position: "absolute", top: 30, left: SZ.sides, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_MONO, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: T.light.muted}}>SISTEMA DE MARKETING</div>
  );
};

export const Video08Resolucao: React.FC = () => (
  <AbsoluteFill style={{backgroundColor: T.light.bg}}>
    <Sequence from={0} durationInFrames={300}>
      <AbsoluteFill style={{justifyContent: "center", alignItems: "flex-start", padding: `${SZ.top}px ${SZ.sides}px ${SZ.bottom}px`}}>
        <SeriesLabel />
        <Headline size={44} color={T.light.headline} delay={5}>
          Marketing previsível existe.<br />É sistema.
        </Headline>
        <Checklist
          items={[
            "Processo documentado e replicável",
            "Métricas claras (CAC, LTV, ROI)",
            "Funil automatizado com CRM",
            "IA como base operacional",
          ]}
          delay={20}
        />
        <Footer />
      </AbsoluteFill>
    </Sequence>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
